const ContractDataFormCtrl = 
    ['$scope', '$filter', '$http', 'Contract', 'SUPPLY_RATES', 'CURRENT_SUPPLY_RATES', 'CONTRACT_REGULARITIES',
        'CONTRACT_ORIGINS', 'CONTRACT_MODE', 'NORMAL_POWERS', 'SUPPLY_POWER_PERIODS', 'CONTRACT_CHANNELS',
        'CreateContract', 'CnaesMaster', 'ProductRatesMaster', 'AgreementsMaster', 'AgreementAPI', 'CitiesMaster',
    function ($scope, $filter, $http, Contract, SUPPLY_RATES, CURRENT_SUPPLY_RATES, CONTRACT_REGULARITIES,
              CONTRACT_ORIGINS, CONTRACT_MODE, NORMAL_POWERS, SUPPLY_POWER_PERIODS, CONTRACT_CHANNELS,
              CreateContract, CnaesMaster, ProductRatesMaster, AgreementsMaster, AgreementAPI, CitiesMaster) {
        /***********************************************************************************************************
        * Controller Attributes
        ***********************************************************************************************************/
        var self = this;
        var $translate = $filter('translate');
        var api_check_rate = API_URL + '/api/1.0/rate-valid-in-product-rate/';
        var product_prices = API_URL + '/api/1.0/product-prices/';

        /***********************************************************************************************************
        * Scope Attributes
        ***********************************************************************************************************/
        $scope.message = $translate('CONTRACTS.CLOSE_PAGE');
        $scope.contract = null;
        $scope.rates = CURRENT_SUPPLY_RATES;

        $scope.regularities = CONTRACT_REGULARITIES;
        $scope.drafts_origins = CONTRACT_ORIGINS;
        $scope.normal_powers = NORMAL_POWERS;
        $scope.channels = CONTRACT_CHANNELS;

        $scope.range_errors = {
            T20A: $translate('CONTRACTS.RANGE_ERROR_20A'),
            T20DHA: $translate('CONTRACTS.RANGE_ERROR_20DHA'),
            T21A: $translate('CONTRACTS.RANGE_ERROR_21A'),
            T21DHA: $translate('CONTRACTS.RANGE_ERROR_21DHA'),
            T30A: $translate('CONTRACTS.RANGE_ERROR_30A'),
            T31A: $translate('CONTRACTS.RANGE_ERROR_31A'),
            T31DHA: $translate('CONTRACTS.RANGE_ERROR_31DHA'),
            T61: $translate('CONTRACTS.RANGE_ERROR_61'),
            T61A: $translate('CONTRACTS.RANGE_ERROR_61'),
            T61B: $translate('CONTRACTS.RANGE_ERROR_61'),
            T62: $translate('CONTRACTS.RANGE_ERROR_62'),
            T63: $translate('CONTRACTS.RANGE_ERROR_63'),
            T64: $translate('CONTRACTS.RANGE_ERROR_64'),
            T65: $translate('CONTRACTS.RANGE_ERROR_65')
        };

        $scope.payment_methods = [
            {code: 'TRF', label: $translate('INVOICES.TRANSFER')},
            {code: 'DBT', label: $translate('INVOICES.DEBIT')},
            {code: 'B2B', label: $translate('INVOICES.DEBIT_B2B')},
            {code: 'GBT', label: $translate('INVOICES.DEBIT_GBT')}
        ];

        $scope.solar_community_types = [
            {code: 1, label: $translate('INVOICES.YES')},
            {code: 0, label: $translate('INVOICES.NO')}
        ];

        $scope.see_copy_agreement_option = false;
        $scope.rate_product_dont_match = false;

        $scope.energy_prices = new Array(6).fill(0);
        $scope.power_prices = new Array(6).fill(0);
        $scope.has_energy_powr_prices = false;

        /***********************************************************************************************************
        * Scope Watchers
        ***********************************************************************************************************/
        $scope.$watch('contract.rate', function (newValue, oldValue) {
            if ($scope.contract) {
                $scope.contract.regularity = $scope.regularities[0];
            }
        });

        $scope.$watch('contract.agreement', function (newValue, oldValue) {
            if ($scope.contract && newValue != undefined) {
                $scope.loadAgreement();
            }

        });

        $scope.$watch('contract.idn', function (newValue, oldValue) {
            if (newValue) {
                Contract.get({idn: newValue}, function (contract) {
                    if (contract.count !== 0) {
                        $scope.contractData.contract_id.$setValidity('api', false);
                        $scope.contractData.contract_id.$error.api = $translate('CONTRACTS.This contract number already exists');
                    }
                    else {
                        delete $scope.contractData.contract_id.$error.api;
                        $scope.contractData.contract_id.$setValidity('api', true);
                    }
                });
            }
        });

        $scope.$watch('contractData.$valid', function (newValue, oldValue) {
            $scope.$emit("setValidity", newValue);

            if (newValue)
                CreateContract.setContractData($scope.contract);
            else
                CreateContract.setContractData(null);
        }, true);

        $scope.$on('customerLoaded', function(event, data) { 
            $scope.checkPrintable(data);
            if ($scope.contract) $scope.contract.flat_rate = '0';
         })

        $scope.$watchGroup(['contract.rate', 'contract.product_rate', 'contract.invoicing_mode'], function (newValues, oldValues, scope) {
            $scope.rate_product_dont_match = false;
            if (newValues[0] && newValues[1] && newValues[2]) {
                var data = {
                    "product_rate": newValues[1],
                    "rate": newValues[0]
                };

                $http.post(api_check_rate, data).then(function (data, status, headers, config) {
                    if (!data.data.has_prices) {
                        $scope.contractData.contract_product_rate.$setValidity('api', false);
                        $scope.contractData.contract_product_rate.$error.api = '';
                        $scope.rate_product_dont_match = true;
                    } else {
                        if ($scope.contractData.contract_product_rate.$error.api) {
                            delete $scope.contractData.contract_product_rate.$error.api;
                        }
                        $scope.contractData.contract_product_rate.$setValidity('api', true);
                        $scope.rate_product_dont_match = false;
                    }
                }, function (data, status, headers, config) {});
            }
        });

        $scope.$watchGroup(['contract.rate', 'contract.product_rate'], function (newValues, oldValues, scope) {
            $scope.energy_prices = new Array(6).fill(0);
            $scope.power_prices = new Array(6).fill(0);
            $scope.has_energy_powr_prices = false;
            if (newValues[0] && newValues[1]) {
                let date = self.formatDate();
                let days = self.leapYear() ? 366 : 365;
                let url_get = product_prices + '?product_rate=' + newValues[1] + '&rate=' + newValues[0] + '&date_active=' + date;

                $http.get(url_get, {}).then(function (data, status, headers, config) {
                    let res = data.data.results;
                    for (let el = 0; el < res.length; el++){
                        let code = res[el]['product']['code']
                        let value = res[el]['value']
                        let code_str = code.substr(code.length-3, 2);
                        let period = code.substr(code.length-1, 1);
                        if (code_str === 'EP') {
                            $scope.energy_prices.splice(period-1, 1, value);
                        }
                        if (code_str === 'PP') {
                            $scope.power_prices.splice(period-1, 1, value * days);
                        }
                    }
                    $scope.has_energy_powr_prices = true;
                });
            }
        });

        /***********************************************************************************************************
        * Controller Methods
        ***********************************************************************************************************/
        this.formatDate = function () {
            let d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;
            return [year, month, day].join('-');
        };

        this.leapYear = function () {
            let year = new Date().getFullYear();
            return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
        };

        this.fillData = function (data, from) {
            if (data) {
                $scope.contract.contact_phone = null;
                $scope.contract.contact_mobile = null;
                if (from === 'agreement'){
                    if ($scope.contract == null)
                        $scope.contract = {};
                    if(data.contact_email)
                        $scope.contract.email = data.contact_email;
                    $scope.contract.print_invoices = data.receive_paper_invoices;
                    $scope.contract.name = data.contact_name;
                    $scope.contract.surname_1 = data.contact_surname_1;
                    $scope.contract.surname_2 = data.contact_surname_2;
                    $scope.contract.address = data.contact_address;
                    $scope.contract.city = data.contact_city;
                    $scope.contract.state = data.contact_state;
                    $scope.contract.zip = data.contact_zip;
                    if(data.contact_phone)
                        $scope.contract.contact_phone = parseInt(data.contact_phone);
                }
                else {
                    if ($scope.contract == null)
                        $scope.contract = {};
                    if (data.email)
                        $scope.contract.email = data.email;
                    $scope.contract.name = data.name;
                    $scope.contract.surname_1 = data.surname_1;
                    $scope.contract.surname_2 = data.surname_2;
                    $scope.contract.address = data.address;
                    $scope.contract.city = data.city;
                    $scope.contract.state = data.state;
                    $scope.contract.zip = data.zip;

                    if (from === 'customer'){
                        $scope.contract.contact_phone = parseInt(data.phone);
                        $scope.contract.contact_mobile = parseInt(data.mobile);
                    }
                }
            }
        };

        /***********************************************************************************************************
        * Scope Methods
        ***********************************************************************************************************/
        $scope.powerActive = function (powerIndex, type) {
            if (type == 'supply')
                return angular.isDefined($scope.supply) && $scope.supply != null &&
                    angular.isDefined($scope.supply.rate) && $scope.supply.rate != '' &&
                    !SUPPLY_POWER_PERIODS[$scope.supply.rate][powerIndex - 1];
            else if (type == 'contract')
                return angular.isDefined($scope.contract) && $scope.contract != null &&
                    angular.isDefined($scope.contract.rate) && $scope.contract.rate != '' &&
                    !SUPPLY_POWER_PERIODS[$scope.contract.rate][powerIndex - 1];
            else
                return true;
        };

        $scope.powerNormal = function () {
            if (angular.isDefined($scope.contract) && $scope.contract != null && angular.isDefined($scope.contract.rate)) {
                for (var i = 1; i < 7; i++) {
                    if (!$scope.powerActive(i, 'contract')) {
                        if ($scope.contract['power_p' + i] !== undefined && $scope.normal_powers.indexOf($scope.contract['power_p' + i]) < 0) {
                            return false;
                        }
                    }
                }
                return true;
            }
            return true;
        };

        $scope.pastePostalData = function (from) {
            var data = null;
            if (from == 'supply') {
                data = CreateContract.getSupply();
            } else if (from == 'customer') {
                data = CreateContract.getCustomer();
            } else if (from == 'agreement') {
                data = CreateContract.getAgreement();
                var customer = CreateContract.getCustomer();
                if (customer !== undefined) {
                    data.contact_name = customer.name;
                    data.contact_surname_1 = customer.surname_1;
                    data.contact_surname_2 = customer.surname_2;
                }
            }

            if (data !== undefined) {
                self.fillData(data, from);
            }
        };

        $scope.pasteSupplyPowers = function () {
            var data = CreateContract.getSupply();

            if (data) {
                if ($scope.contract == null)
                    $scope.contract = {};

                $scope.contract.power_p1 = data.power_p1;
                $scope.contract.power_p2 = data.power_p2;
                $scope.contract.power_p3 = data.power_p3;
                $scope.contract.power_p4 = data.power_p4;
                $scope.contract.power_p5 = data.power_p5;
                $scope.contract.power_p6 = data.power_p6;
                $scope.contract.rate = data.rate;
            }
        };

        $scope.loadAgreement = function () {
            if ($scope.contract.agreement) {

                AgreementAPI.getAgreementDetail($scope.contract.agreement)
                    .then(function (data) {
                        CreateContract.setAgreement(data);
                    });
            }
        };
        
        $scope.checkPrintable = function(data) {
            $scope.contract.print_invoices = false;
            if (data && data.vat_id) {
                if (data.vat_id.substring(0, 1) == 'H' || data.vat_id.substring(0, 1) == 'E') {
                    $scope.contract.print_invoices = true;
                }
            }
        }
        /***********************************************************************************************************
        * Controller Initialization
        ***********************************************************************************************************/


        AgreementsMaster.loadAgreements().then(function (response){
            $scope.agreements = response;
        });

        ProductRatesMaster.loadProductRatesNotForce().then(function (response){
            $scope.product_rates = response;
        });

        CnaesMaster.loadCnaes().then(function (response){
            $scope.cnaes = response;
        });

        CitiesMaster.loadCities().then(function(response){
            $scope.cities=response;
        });

    }]

export {ContractDataFormCtrl}
